import mondaySdk from "monday-sdk-js";
import "monday-ui-react-core/dist/main.css";
const token = "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjI0MjIzNjc2OSwidWlkIjo0MDMzMTU2NiwiaWFkIjoiMjAyMy0wMy0wN1QxMjoyNDowNS4wMDBaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6NzYxMzc0MywicmduIjoidXNlMSJ9.YzNj36R7J3kqRPM6M02XTnz4PbUFTjRG9a1xriSTHTc";
// const token = "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjEzODM2MDg1MCwidWlkIjoyNjY2MTU5MSwiaWFkIjoiMjAyMS0xMi0yNFQxNDowOTo1NC4wMDBaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6NzYxMzc0MywicmduIjoidXNlMSJ9.yT55yLQ6I6MNMA0-FSY8M9Dkx3N70aAYkv5NT6NXA94"
const monday = mondaySdk();
monday.setToken(token);


export const getAssetValueProcess=async(assetId)=>{
  try{
    const query=`query {
      items (ids: [${assetId}]) {
          id
          name
          column_values{
            id
            type
            text
            title
          }
        }
      }`;
    const response= await monday.api(query);
    return response.data.items[0];
  }catch(err){

  }
}

export const mondayContextProcess=async()=>{
  try{
      const contextResponse=await monday.get('context');
      return contextResponse.data;
  }catch(err){

  }
}

export const statusChange=async(assetRequestBoardId,requestId,statusValue)=>{
  try{
    const query = 'mutation ($boardId:Int!,$itemId:Int!,$columnVals: JSON!) { change_multiple_column_values(board_id:$boardId, item_id:$itemId, column_values:$columnVals) { id } }';
    const variables=JSON.stringify({
      "boardId":parseInt(assetRequestBoardId),
      "itemId":parseInt(requestId),
      "columnVals":JSON.stringify({
          "status":{"label" : statusValue},
      })
    })
    const response=await monday.api(query,{variables});
    return response;

  }catch(err){

  }

}

export const getParticularBoardId=async(boardWorkspaceId,boardName)=>{
  try{
    let particularBoardId;
    const readAllBoardQuery=`{ boards(workspace_ids:${boardWorkspaceId})  { name id } }`;
    const readAllBoardQueryResponse=await monday.api(readAllBoardQuery);
    const getAllBoardResponse=readAllBoardQueryResponse.data.boards;
    for(let getEmpOrAllocationTypeBoard of getAllBoardResponse){
        if(getEmpOrAllocationTypeBoard.name===boardName){
          particularBoardId=getEmpOrAllocationTypeBoard.id
        }
    }
    return particularBoardId;

  }catch(err){
    
}

}

export const createItemToAllocationBoard=async(allocationBoardId,assetName)=>{
  try{
    const createItemQuery=`mutation { create_item (board_id: ${allocationBoardId}, item_name: "${assetName}") { id } }`;
    const createItemResponse=await monday.api(createItemQuery);
    return createItemResponse.data.create_item.id;
  }catch(err){
      
  }

}

export const populateColumnValuesInAllocationBoard=async(getAllocationBoardId,createItemIdInAllocationBoard,assetId,assetType,employeeId,getDateConversion,allocateComment,requestId,employeeName)=>{
  try{
    const columnPopulateQuery = 'mutation ($boardId:Int!,$itemId:Int!,$columnVals: JSON!) { change_multiple_column_values(board_id:$boardId, item_id:$itemId, column_values:$columnVals) { id } }';
    const variables=JSON.stringify({
        "boardId":parseInt(getAllocationBoardId),
        "itemId":parseInt(createItemIdInAllocationBoard),
        "columnVals":JSON.stringify({
            "text80":assetId,
            "text2":assetType,
            "text":employeeId,
            "text79":employeeName,
            "date":{"date" : getDateConversion},
            "text8":{"text":allocateComment},
            "connect_boards":{"item_ids":[parseInt(requestId)]},
        })
    })
    const response=await monday.api(columnPopulateQuery,{variables});
    return response.data;

  }catch(err){

  }

}

export const statusChangeToSomething=async(assetRequestBoardId,assetRequestItemId,statusValue,getDateConversion)=>{
  try{
      const query = 'mutation ($boardId:Int!,$itemId:Int!,$columnVals: JSON!) { change_multiple_column_values(board_id:$boardId, item_id:$itemId, column_values:$columnVals) { id } }';
      if(getDateConversion!==null){
          const variables=JSON.stringify({
              "boardId":parseInt(assetRequestBoardId),
              "itemId":parseInt(assetRequestItemId),
              "columnVals":JSON.stringify({
                  "status":{"label" : statusValue},
                  "date":{"date" : getDateConversion},
              })
          })
          const response=await monday.api(query,{variables});
          return response.data;
      }
      else{
          const variables=JSON.stringify({
              "boardId":parseInt(assetRequestBoardId),
              "itemId":parseInt(assetRequestItemId),
              "columnVals":JSON.stringify({
                  "status":{"label" : statusValue},
              })
          })
          const response=await monday.api(query,{variables});
          return response.data;
      }
      
  }catch(err){

  }
}

export const readParticularBoard=async(boardId)=>{
  try{
      const query=`{
          boards(ids:${boardId}){
            id
            name
            items{
              id 
              name
              column_values{
                id
                title
                type
                text
              }
            }
          }
        }`;
      const response=await monday.api(query);
      return response.data.boards[0].items;

  }catch(err){

  }
}

export const mondatLocationProcess=async()=>{
  const response=monday.get("location");
  return response;
}

export const returnAllocationProcess=async(allocationBoardId,allocationItemId,getDateConversion,returnComments)=>{
  try{
      const columnPopulateQuery = 'mutation ($boardId:Int!,$itemId:Int!,$columnVals: JSON!) { change_multiple_column_values(board_id:$boardId, item_id:$itemId, column_values:$columnVals) { id } }';
      const variables=JSON.stringify({
          "boardId":parseInt(allocationBoardId),
          "itemId":parseInt(allocationItemId),
          "columnVals":JSON.stringify({
              "date2":{"date" : getDateConversion},
              "long_text6":{"text":returnComments},
          })
      })
      const response=await monday.api(columnPopulateQuery,{variables});
      return response.data;

  }catch(err){

  }
}

export const successOrErrorMessageNotice=async(successMessage,messageType)=>{
  const data=await monday.execute("notice", { 
      message: successMessage,
      type: messageType, 
      timeout: 10000,
  });
}


export const dateConvertion=async(date)=>{
  try{
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
  }catch(err){
      
  }
}
